//
//
//
//
//
//
//
//

import DetailWeblog from '~/components/detail/mobile/detail_weblog'
// import Questions from '~/components/detail/desktop/questions'
import Tags from '~/components/detail/desktop/tags'
export default {
  name: 'CoinWeblog',
  components: {
    DetailWeblog,
    // Questions,
    Tags
  },
  props: {
    coin: {
      type: Object,
      default: null
    }
  }
}
